import { StyledIconWrapper } from "./icon.styles";
import { MDSIconColor, MDSIconKind, MDSIconProps } from "./icon.types";
import { customIconMapping, fontAwesomeIconMapping } from "./icon.mapping";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const MDSIcon = ({
  kind,
  size = 14,
  boxSize = 16,
  color = MDSIconColor.Primary,
  overrideColor,
  ...props
}: MDSIconProps) => {
  // Custom Icons
  if (kind in customIconMapping) {
    const CustomIconComponent = customIconMapping[kind];
    if (CustomIconComponent) {
      return (
        <StyledIconWrapper
          $boxSize={boxSize}
          $iconSize={size}
          $color={color}
          $overrideColor={overrideColor}
          className="mds-icon-wrapper"
          {...props}
        >
          <CustomIconComponent className="mds-icon" />
        </StyledIconWrapper>
      );
    }
  }

  // Font Awesome Icons
  const iconDefinition = fontAwesomeIconMapping[kind];
  const shouldSpin = [
    MDSIconKind.Spinner,
    MDSIconKind.SpinnerSolid,
    MDSIconKind.SpinnerThird,
  ].includes(kind);

  return (
    <StyledIconWrapper
      $boxSize={boxSize}
      $iconSize={size}
      $color={color}
      $overrideColor={overrideColor}
      className="mds-icon-wrapper"
      {...props}
    >
      <FontAwesomeIcon icon={iconDefinition} className="mds-icon" spin={shouldSpin} />
    </StyledIconWrapper>
  );
};
